<template>
  <div class="funModel">
    <div class="titleWrap">
      <div class="setTitle">{{ name }}</div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item v-if="url === '/permission'" :to="{ path: url }">{{ pname }}</el-breadcrumb-item>
        <el-breadcrumb-item v-else :to="{ path: url + '?id=' + pid + '&pid=' + topid + '&topid=' + '' + '&pname=' + pname + '&name=' + name + '&url=' + url }">{{ pname }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ name }}</el-breadcrumb-item>
        <el-breadcrumb-item>功能模块</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button class="myBtn" type="primary" size="small" @click="add">新增</el-button>
      <div class="clearfix"></div>
    </div>
    <el-main class="tableWrap">
      <el-input class="input" v-model.trim="permissionName" size="small" placeholder="权限名称"></el-input>
      <el-select class="select" v-model="status" size="small" filterable clearable placeholder="状态">
        <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-button class="searchBtn" type="primary" size="small" @click="search"><i class="el-icon-search"></i></el-button>
      <div class="clearfix"></div>
      <el-table :data="permissionAttr" class="list">
        <el-table-column type="index" label="序号" width="80" :index="indexMethod" :align="align"></el-table-column>
        <el-table-column prop="name" label="功能名称" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="operationCode" label="功能标识符" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="state" label="状态" min-width="180" :align="align">
          <template slot-scope="scope">
            <div class="state open" v-if="scope.row.state === 'Y'"></div>
            <span v-if="scope.row.state === 'Y'">启用</span>
            <div class="state close" v-if="scope.row.state === 'N'"></div>
            <span v-if="scope.row.state === 'N'">禁用</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" min-width="90" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="edit(scope.row.id)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page.sync="permissionCurr" :page-sizes="[10, 20, 50]" :page-size="permissionSize" :total="permissionTotal" @current-change="permissionCurrChange" @size-change="permissionSizeChange"></el-pagination>
    </el-main>
    <!-- 新增编辑权限弹出层 -->
    <el-dialog :visible.sync="dialog" :title="title" width="500px" :close-on-click-modal="false" @close="notBtn">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
        <el-form-item label="父级权限">
          <el-input v-model.trim="name" disabled placeholder="父级权限"></el-input>
        </el-form-item>
        <el-form-item label="功能名称" prop="permissionName">
          <el-input v-model.trim="form.permissionName" placeholder="功能名称"></el-input>
        </el-form-item>
        <el-form-item label="功能标识符" prop="permissionCode">
          <el-input v-model.trim="form.permissionCode" placeholder="功能标识符"></el-input>
        </el-form-item>
        <!-- <el-form-item label="权限地址" prop="permissionUrl">
          <el-input v-model.trim="form.permissionUrl" placeholder="权限地址"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="权限图标">
          <el-input v-model.trim="form.permissionIcon" placeholder="权限图标"></el-input>
        </el-form-item> -->
        <el-form-item label="权限排序" prop="permissionSort">
          <el-input v-model.trim.number="form.permissionSort" placeholder="权限排序"></el-input>
        </el-form-item>
        <!-- <el-form-item label="权限类型" :required="true">
          <el-switch v-model="form.permissionType" active-text="功能" inactive-text="菜单"></el-switch>
        </el-form-item> -->
        <el-form-item label="权限状态" :required="true">
          <el-switch v-model="form.permissionStatus" active-text="启用" inactive-text="停用"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="notBtn">取 消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="okBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'FunModel',
  data () {
    return {
      align: this.$align, // 表格对齐方式
      topid: '', // 顶级权限Id
      pid: '', // 父权限Id
      id: '', // 该权限Id
      pname: '', // 父权限名称
      name: '', // 该权限名称
      url: '', // 父权限页面url
      permissionName: '', // 权限名称查询输入框
      status: '', // 权限状态
      statusList: [], // 权限状态下拉框
      permissionAttr: [], // 权限列表
      permissionTotal: 0, // 权限总数
      permissionSize: 10, // 权限每页条数
      permissionCurr: 1, // 权限当前页数
      dialog: false, // 权限弹出层状态
      title: '', // 权限弹出层标题
      loading: false, // 权限弹出层确定按钮loading
      form: {
        id: '', // 权限Id
        parentPermission: '', // 父类权限Id
        parentPermissionList: [], // 父类权限下拉框
        permissionName: '', // 功能名称
        permissionCode: '', // 功能标识符
        permissionUrl: '', // 权限地址
        permissionIcon: '', // 权限图标
        permissionSort: '', // 权限排序
        permissionType: true, // 权限类型
        permissionStatus: true // 权限状态
      },
      rules: {
        permissionName: [
          {
            required: true,
            message: '请输入功能名称',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z\u4e00-\u9fa5]+$/
              if (!reg.test(value)) {
                callback(new Error('功能名称由中英文字符及数字组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        permissionCode: [
          {
            required: true,
            message: '请输入功能标识符',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z]+$/
              if (!reg.test(value)) {
                callback(new Error('功能标识符由英文字符及数字组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        permissionUrl: [
          {
            required: true,
            message: '请输入权限地址',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z/]+$/
              if (!reg.test(value)) {
                callback(new Error('权限地址由英文字符、数字及斜杠组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        permissionSort: [
          {
            required: true,
            message: '请输入权限排序',
            trigger: ['blur', 'change']
          },
          {
            type: 'number',
            message: '权限排序为数值',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              if (value < 1) {
                callback(new Error('权限排序必须大于0'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  mounted () {
    // 顶级权限Id
    this.topid = this.$route.query.topid
    // 父权限Id
    this.pid = this.$route.query.pid
    // 该权限Id
    this.id = this.$route.query.id
    // 父权限名称
    this.pname = this.$route.query.pname
    // 该权限名称
    this.name = this.$route.query.name
    // 父权限页面url
    this.url = this.$route.query.url

    // 获取权限状态下拉框
    this.statusList = [
      {
        id: 'Y',
        name: '启用'
      },
      {
        id: 'N  ',
        name: '禁用'
      }
    ]

    // 获取权限树
    this.getPermissionTree()
    // 获取权限列表
    this.getPermissionList(this.permissionCurr, this.permissionSize)
  },
  methods: {
    getPermissionList (page, size) {
      this.$http.get(this.$api.permission_list, {
        params: {
          pageNum: page,
          pageSize: size,
          name: this.permissionName,
          state: this.status,
          pid: this.id
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.permissionAttr = data.data.list
          this.permissionTotal = data.data.total
          this.permissionSize = size
          this.permissionCurr = page
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    getPermissionTree () {
      this.$http.get(this.$api.permission_tree).then((res) => {
        let data = res.data

        if (data.success) {
          this.form.parentPermissionList = data.data
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    search () {
      this.getPermissionList(1, this.permissionSize)
    },
    add () {
      this.dialog = true
      this.title = '新增权限'
    },
    edit (id) {
      this.$http.get(this.$api.permission_detail, {
        params: {
          id: id
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.form.id = id
          this.form.parentPermission = data.data.pid
          this.form.permissionName = data.data.name
          this.form.permissionCode = data.data.operationCode
          this.form.permissionUrl = data.data.url
          this.form.permissionIcon = data.data.icon
          this.form.permissionSort = data.data.sortNum
          if (data.data.isOperation === 'N') {
            this.form.permissionType = false
          }
          if (data.data.isOperation === 'Y') {
            this.form.permissionType = true
          }
          if (data.data.state === 'N') {
            this.form.permissionStatus = false
          }
          if (data.data.state === 'Y') {
            this.form.permissionStatus = true
          }
          this.dialog = true
          this.title = '编辑权限'
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    subMenu (id, pname, name, url) {
      this.$router.push('subMenu?id=' + id + '&pname=' + pname + '&name=' + name + '&url=' + url)
    },
    funModel (id, pname, name, url) {
      this.$router.push('funModel?id=' + id + '&pname=' + pname + '&name=' + name + '&url=' + url)
    },
    notBtn () {
      this.$refs.form.resetFields()
      this.form.id = ''
      this.form.parentPermission = ''
      this.form.permissionName = ''
      this.form.permissionCode = ''
      this.form.permissionUrl = ''
      this.form.permissionIcon = ''
      this.form.permissionSort = ''
      this.form.permissionType = true
      this.form.permissionStatus = true
      this.loading = false
      this.dialog = false
    },
    okBtn () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          let formData = new FormData()
          formData.append('id', this.form.id)
          formData.append('pid', this.id)
          formData.append('name', this.form.permissionName)
          formData.append('operationCode', this.form.permissionCode)
          formData.append('url', '/')
          formData.append('icon', this.form.permissionIcon)
          formData.append('sortNum', this.form.permissionSort)
          if (this.form.permissionType) {
            formData.append('isOperation', 'Y')
          } else {
            formData.append('isOperation', 'N')
          }
          if (this.form.permissionStatus) {
            formData.append('state', 'Y')
          } else {
            formData.append('state', 'N')
          }

          if (this.form.id === '') {
            this.$http({
              method: 'post',
              url: this.$api.permission_add,
              data: formData
            }).then((res) => {
              let data = res.data

              if (data.success) {
                this.$message({
                  message: '新增权限成功',
                  type: 'success',
                  duration: 1000
                })
                this.notBtn()
                this.getPermissionList(this.permissionCurr, this.permissionSize)
                this.getPermissionTree()
              } else {
                this.$message({
                  type: 'error',
                  message: data.msg,
                  duration: 1000
                })
                this.loading = false
              }
            }).catch((err) => {
              console.log(err)
              this.loading = false
            })
          } else {
            this.$http({
              method: 'post',
              url: this.$api.permission_edit,
              data: formData
            }).then((res) => {
              let data = res.data

              if (data.success) {
                this.$message({
                  message: '编辑权限成功',
                  type: 'success',
                  duration: 1000
                })
                this.notBtn()
                this.getPermissionList(this.permissionCurr, this.permissionSize)
                this.getPermissionTree()
              } else {
                this.$message({
                  type: 'error',
                  message: data.msg,
                  duration: 1000
                })
                this.loading = false
              }
            }).catch((err) => {
              console.log(err)
              this.loading = false
            })
          }
        } else {
          return false
        }
      })
    },
    permissionCurrChange (curr) {
      this.permissionCurr = curr
      this.getPermissionList(curr, this.permissionSize)
    },
    permissionSizeChange (size) {
      this.permissionSize = size
      this.getPermissionList(this.permissionCurr, size)
    },
    notData (str) {
      return this.$null(str)
    },
    operateTime (time) {
      if (time === '' || time === null) {
        return '-'
      } else {
        return time.substr(0, 4) + '-' + time.substr(5, 2) + '-' + time.substr(8, 2) + ' ' + time.substr(11, 2) + ':' + time.substr(14, 2) + ':' + time.substr(17, 2)
      }
    },
    indexMethod (index) {
      // index从0开始
      return index + 1 + (this.permissionCurr - 1) * this.permissionSize
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.funModel
  box-sizing border-box
  padding 80px 20px 60px
  width 100%
  height 100%
  background-color #F5F7FA
  .titleWrap
    width 100%
    height 32px
    .setTitle
      float left
      height 32px
      line-height 32px
      font-weight bold
      font-size 18px
      color #333
    .el-breadcrumb
      float left
      margin-left 20px
      height 32px
      line-height 32px
      font-size 12px
    .myBtn
      float right
  .tableWrap
    margin-top 20px
    padding-left 0px
    padding-right 0px
    background-color #fff
    border-radius 4px
    box-shadow 0 3px 5px 0 rgba(0, 0, 0, .05)
    .select
      float left
      margin-left 20px
      width 160px
    .input
      float left
      margin-left 20px
      width 160px
    .time
      float left
      margin-left 20px
    .searchBtn
      float left
      margin-left 20px
      padding 5.5px 6px
      font-size 18px
    .list
      margin-top 20px
      &>>>thead
        tr, th
          color #666
          background-color #fafafa
          .cell
              font-weight bold
      &>>>tbody
        tr, th
          color #333
      &>>>td
        padding 7px 0
      .cell
        line-height 26px
        .state
          display inline-block
          width 10px
          height 10px
          border-radius 50%
          &.open
            background-color #60ACFC
          &.close
            background-color #ccc
    .el-pagination
      margin-top 20px
      padding 0 20px 0
      text-align right
  &>>>.el-dialog
    .el-dialog__header
      border-bottom 1px solid #eee
    .el-dialog__body
      max-height 300px
      overflow auto
      .el-form
        width 350px
        .el-select
          width 100%
</style>



// WEBPACK FOOTER //
// src/components/system/funModel.vue